import { DeviceOSEnum } from '@portal/models/enumerators';
import { DeviceStatus } from '@portal/enum/device';
import { translate } from '@portal/services/i18n';
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DateTime } from 'luxon';
import React from 'react';
import { getLogoBrand } from '~/utils/logo';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import ThemedText from '@portal/components/ThemedText/ThemedText';

const logoSize = {
  width: 30,
  height: 30,
};
interface IDeviceCard {
  os?: DeviceOSEnum | 'android' | 'apple' | 'firefox' | 'chrome' | string;
  brand?: string;
  lastAccess?: string;
  deviceId?: string;
  onPress?: () => void;
  onBlock?: () => void;
  onUnlock?: () => void;
  onUnblock?: () => void;
  isBlockedDevices?: boolean;
  status?: DeviceStatus;
  login?: string;
  userName?: string;
}

const DeviceCard = ({
  os,
  brand,
  lastAccess,
  deviceId,
  onPress,
  onBlock,
  onUnlock,
  onUnblock,
  isBlockedDevices,
  status,
  login,
  userName,
}: IDeviceCard) => {
  const Logo = getLogoBrand(os as string);
  const formattedDate = lastAccess
    ? DateTime.fromISO(lastAccess).toFormat('dd/MM/yyyy')
    : null;
  const formattedTime = lastAccess
    ? DateTime.fromISO(lastAccess).toFormat('HH:mm')
    : null;

  const getButtons = () => {
    if (isBlockedDevices) {
      return (
        <AdvancedButton
          text={translate('COMPONENTS.DEVICE_CARD.UNLOCK')}
          onClick={onUnlock}
          fullWidth
        />
      );
    }

    if (status === DeviceStatus.BLOCKED) {
      return (
        <AdvancedButton
          text={translate('COMPONENTS.DEVICE_CARD.UNLOCK')}
          onClick={onUnblock}
          fullWidth
        />
      );
    }

    return (
      <>
        <AdvancedButton
          text={translate('COMPONENTS.DEVICE_CARD.DISCONNECT')}
          onClick={onPress}
          fullWidth
          variant="outlined"
        />
        <AdvancedButton
          text={translate('COMPONENTS.DEVICE_CARD.BLOCK_DEVICE')}
          onClick={onBlock}
          fullWidth
        />
      </>
    );
  };

  const thisDeviceId = localStorage.getItem('device-id');

  return (
    <div className="device-card">
      <div className="device-card__header">
        <div className="device-card__device_info">
          <div className="device-card__logo">
            <Logo {...logoSize} />
          </div>
          <div className="device-card__titles">
            {deviceId === thisDeviceId && (
              <ThemedText className="device-card__badge">
                {translate('COMPONENTS.DEVICE_CARD.THIS_DEVICE')}
              </ThemedText>
            )}
            <ThemedText variant="body" className="device-card__brand">
              {brand || translate('UNKNOWN_DEVICE')}
            </ThemedText>
          </div>
        </div>
        <div className="device-card__actions">{getButtons()}</div>
      </div>
      <div className="device-card__footer">
        {login || userName ? (
          <div className="device-card__user_info" title={userName || login}>
            <UserOutlined />
            <ThemedText className="device-card__user-text">
              {userName ? (
                <span className="device-card__username">{userName}</span>
              ) : null}
              {login ? (
                <span className="device-card__login">({login})</span>
              ) : null}
            </ThemedText>
          </div>
        ) : null}
        <div className="device-card__access">
          <ClockCircleOutlined />
          <ThemedText className="device-card__access-text">
            {lastAccess ? `${formattedDate} ${formattedTime}` : '—'}
          </ThemedText>
        </div>
      </div>
    </div>
  );
};

export default DeviceCard;
